"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var React = require("react");
var Wrapper = /** @class */ (function (_super) {
    __extends(Wrapper, _super);
    function Wrapper(props) {
        return _super.call(this, props) || this;
    }
    Wrapper.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className, style: Object.assign({}, this.props.padding ?
                { padding: this.props.padding } : {}, this.props.paddingVertical ?
                { paddingTop: this.props.paddingVertical, paddingBottom: this.props.paddingVertical } : {}, this.props.paddingHorizontal ?
                { paddingLeft: this.props.paddingHorizontal, paddingRight: this.props.paddingHorizontal } : {}) }, this.props.children));
    };
    return Wrapper;
}(React.Component));
exports.Wrapper = Wrapper;
